import { css } from 'lit';

export const styles = css`
	:host {
		--_sds-process-step-border-width: var(--sds-process-step-border-width, 2px);
		--_sds-process-step-border-color: var(--sds-process-step-border-color, var(--sds-color-action-default, var(--sds-color-main-action-default)));
		--_sds-process-step-marker-sm: var(--sds-process-step-marker-sm, 1rem);
		--_sds-process-step-marker-lg: var(--sds-process-step-marker-lg, 2rem);
		--_sds-process-step-marker-size: var(--_sds-process-step-marker-lg);
		--_sds-process-step-marker-base: var(--sds-process-step-marker-base, 2rem);
		--_sds-process-step-marker-text-color: var(--sds-process-step-marker-text-color, var(--sds-color-action-default, var(--sds-color-main-action-default)));
		--_sds-process-step-marker-background: var(--sds-process-step-marker-background, var(--sds-color-action-contrast-subtle, var(--sds-color-main-action-contrast-subtle)));
		--_sds-process-step-marker-margin-block-start: var(--sds-process-step-marker-margin-block-start, calc((var(--_sds-process-step-marker-lg) - var(--_sds-process-step-marker-sm)) / 2));
		--_sds-process-step-marker-border-radius: var(--sds-process-step-marker-border-radius, var(--sds-radius-full));
		--_sds-process-step-grid-template-rows: var(--sds-process-step-grid-template-rows, [line-1] auto [step-start] var(--_sds-process-step-marker-size) [line-2 step-end] auto);
		--_sds-process-step-grid-template-columns: var(--sds-process-step-grid-template-columns, var(--_sds-process-step-marker-base) auto);
		--_sds-process-step-sub-step-margin-block-start: var(--sds-process-step-sub-step-margin-block-start, calc((var(--_sds-process-step-marker-sm) / 2) * -1));

		--_sds-process-step-item-grid-template-columns: var(--sds-process-step-item-grid-template-columns, [marker] var(--_sds-process-step-marker-base) [content] auto);
		--_sds-process-step-item-grid-area: var(--sds-process-step-item-grid-area, 2 / 1 / -1 / -1);

		--_sds-process-step-line-display: var(--sds-process-step-line-display, block);
		--_sds-process-step-line-min-height: var(--sds-process-step-line-min-height, 2rem);

		--_sds-process-step-heading-color: var(--sds-process-step-heading-color, var(--sds-color-neutral-text-default));
		--_sds-process-step-heading-font-weight: var(--sds-process-step-heading-font-weight, var(--sds-typography-body-sm-strong-desktop-font-weight));
		--_sds-process-step-heading-font-size: var(--sds-process-step-heading-font-size, var(--sds-typography-body-md-desktop-font-size));
		--_sds-process-step-heading-line-height: var(--sds-process-step-heading-line-height, var(--sds-typography-body-md-strong-desktop-line-height));
		--_sds-process-step-heading-padding-block: var(--sds-process-step-heading-padding-block, var(--sds-spacing-3xs));
		--_sds-process-step-heading-margin-block: var(--sds-process-step-heading-margin-block, 0);

		--_sds-process-step-timestamp-color: var(--sds-process-step-timestamp-color, var(--sds-color-neutral-text-subtle));
		--_sds-process-step-timestamp-font-weight: var(--sds-process-step-timestamp-font-weight, var(--sds-typography-body-sm-desktop-font-weight));
		--_sds-process-step-timestamp-font-size: var(--sds-process-step-timestamp-font-size, var(--sds-typography-body-sm-desktop-font-size));
		--_sds-process-step-timestamp-line-height: var(--sds-process-step-timestamp-line-height, var(--sds-typography-body-sm-desktop-line-height));
		--_sds-process-step-timestamp-padding-block-start: var(--sds-process-step-timestamp-padding-block-start, var(--sds-spacing-zero));
		--_sds-process-step-timestamp-padding-block-end: var(--sds-process-step-timestamp-padding-block-end, var(--sds-spacing-3xs));

		--_sds-process-step-slot-content-padding-block: var(--sds-process-step-slot-content-padding-block, var(--sds-spacing-zero));

		--sds-icon-color: var(--_sds-process-step-marker-text-color);
	}

	.sds-process-step {
		display: grid;
		font-family: var(--sds-typography-font-family);
		grid-template-rows: var(--_sds-process-step-grid-template-rows);
		grid-template-columns: var(--_sds-process-step-grid-template-columns);
		justify-items: flex-start;
	}

	.sds-process-step--sub-step {
		--_sds-process-step-marker-background: var(--sds-process-step-marker-background, var(--sds-color-action-default, var(--sds-color-main-action-default)));
		--_sds-process-step-marker-size: var(--_sds-process-step-marker-sm);
		--_sds-process-step-grid-template-rows: var(--sds-process-step-grid-template-rows, [line-1] auto [step-start] var(--_sds-process-step-marker-size) [line-2 step-end] auto);
		margin-block-start: var(--_sds-process-step-sub-step-margin-block-start);

		.sds-process-step__marker {
			margin-block-start: var(--_sds-process-step-marker-margin-block-start);
		}
	}

	.sds-process-step__item {
		grid-area: var(--_sds-process-step-item-grid-area);
		grid-template-columns: var(--_sds-process-step-item-grid-template-columns);
		gap: var(--sds-spacing-xs);
		padding: var(--_sds-process-step-border-width);
		margin: calc(var(--_sds-process-step-border-width) * -1) calc(var(--_sds-process-step-border-width) * -1) var(--sds-spacing-sm);
		justify-content: flex-start;
		width: 100%;
		display: grid;
	}

	.sds-process-step__marker {
		width: var(--_sds-process-step-marker-size);
		height: var(--_sds-process-step-marker-size);
		border-radius: var(--_sds-process-step-marker-border-radius);
		border: var(--_sds-process-step-border-width) solid;
		color: var(--_sds-process-step-marker-text-color);
		background-color: var(--_sds-process-step-marker-background);
		border-color: var(--_sds-process-step-border-color);
		font-weight: var(--sds-typography-body-sm-strong-desktop-font-weight);
		grid-column: marker;
		place-self: baseline center;
		place-items: center;
		line-height: 1;
		display: inline-grid;
	}

	.sds-process-step__content {
		grid-column: content;
	}

	.sds-process-step__line {
		display: var(--_sds-process-step-line-display);
		border: calc(var(--_sds-process-step-border-width) / 2) solid var(--_sds-process-step-border-color);
		grid-column: 1;
		justify-self: center;
		width: 0;
		min-height: var(--_sds-process-step-line-min-height);
		grid-row: line-2;
		position: relative;
		top: var(--_sds-process-step-border-width);
	}

	.sds-process-step__heading {
		color: var(--_sds-process-step-heading-color);
		font-weight: var(--_sds-process-step-heading-font-weight);
		font-size: var(--_sds-process-step-heading-font-size);
		line-height: var(--_sds-process-step-heading-line-height);
		padding-block: var(--_sds-process-step-heading-padding-block);
		margin-block: var(--_sds-process-step-heading-margin-block);
	}

	.sds-process-step__timestamp {
		color: var(--_sds-process-step-timestamp-color);
		font-weight: var(--_sds-process-step-timestamp-font-weight);
		font-size: var(--_sds-process-step-timestamp-font-size);
		line-height: var(--_sds-process-step-timestamp-line-height);
		padding-block-start: var(--_sds-process-step-timestamp-padding-block-start);
		padding-block-end: var(--_sds-process-step-timestamp-padding-block-end);

		&:first-child {
			--_sds-process-step-timestamp-padding-block-start: var(--sds-process-step-timestamp-padding-block-start, var(--sds-spacing-3xs));
		}

		&:empty {
			display: none;
		}
	}

	.sds-process-step__slot-content {
		padding-block: var(--_sds-process-step-slot-content-padding-block);

		&:first-child {
			--_sds-process-step-slot-content-padding-block: var(--sds-process-step-slot-content-padding-block, var(--sds-spacing-3xs));
		}
	}

	:host(:last-of-type) {
		--_sds-process-step-line-display: none;
	}
`;
